import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=d4b7673c"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=d4b7673c&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/harness/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4b7673c')) {
      api.createRecord('d4b7673c', component.options)
    } else {
      api.reload('d4b7673c', component.options)
    }
    module.hot.accept("./Welcome.vue?vue&type=template&id=d4b7673c", function () {
      api.rerender('d4b7673c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Welcome.vue"
export default component.exports